import React from 'react';
import {
  Card,
  CardHeader,
  CardBody,
  Form,
  FormGroup,
  Label,
  Badge,
} from 'reactstrap';
import { HTMLForm } from '../../../CustomForms';

const REGION_TYPES = ['Local', 'International'];

const WorkshopDetailCard = ({
  content,
  notes,
  regionType,
  handleInput,
  handleOption,
}) => {
  return (
    <Card className="my-4">
      <CardHeader>Workshop/Event Details</CardHeader>
      <CardBody>
        <HTMLForm
          {...content}
          label="Mengapa harus mengikuti acara ini"
          onInput={(value) => handleInput('content', value)}
        />
        <HTMLForm
          {...notes}
          label="Notes"
          onInput={(value) => handleInput('notes', value)}
        />

        <Form>
          <FormGroup>
            <Label className="text-gray font-weight-bold">Region Type</Label>

            {regionType.invalid && (
              <Badge className="ml-4" color="danger" style={{ fontSize: 12 }}>
                {regionType.error}
              </Badge>
            )}
            <div className="d-flex flex-row gap-3">
              {REGION_TYPES.map((type, index) => (
                <div
                  key={type}
                  className={`form-check${index === 0 ? ' mr-3' : ''}`}
                >
                  <input
                    type="radio"
                    id={type.toLowerCase()}
                    name="regionType"
                    value={type}
                    checked={regionType.value === type}
                    onChange={() => handleOption('regionType', type)}
                    className="form-check-input"
                  />
                  <Label
                    htmlFor={type.toLowerCase()}
                    className={`form-check-label ${
                      regionType.value === type
                        ? 'font-weight-bold'
                        : 'text-muted'
                    }`}
                  >
                    {type}
                  </Label>
                </div>
              ))}
            </div>
          </FormGroup>
        </Form>
      </CardBody>
    </Card>
  );
};

export default WorkshopDetailCard;
